import * as React from 'react';

interface FormLabelProps {
    label: string;
    color?: string;
    icon?: string;
}

export const FormLabel = ({ label, color = "#f3aaaa", icon }: FormLabelProps) => {
    return (
        <div className="flex flex-row mb-3 items-center">
            {/* <hr className="w-[2px] h-[15px]" style={{ backgroundColor: color }}></hr> */}
            <img className="mr-[6px] h-[15px]" src={icon} />
            <div className="font-b tracking-[0.4px] text-sm">{label}</div>

        </div>
    )
}